import * as React from 'react'
import { connect } from 'react-redux'

import {
  getActiveChannelId
} from '../reducers/gui'

import {
  getPhasesNameById,
  getPhases
} from '../reducers/phases'

import {
  getPhaseIdByChannelId,
  getTimings,
  getDateOfNextPhaseChange,
  getCahnnelIdOfSmallestPhaseChangeDelay,
  getCurrentDelta
} from '../reducers/timings'
import { ONE_THOUSAND_MILLISECONDS } from '../actions/actionTypes';

interface DebugOverlayProps {
  activeChannelId: number
  phaseNameOfActiveChannel: string
  phaseIdOfActiveChannel: number
  dateOfNextPhaseChange: any
  pullDelay: any
  getCahnnelIdOfNextPull: any
  channels: any[]
  phases: any
}

const DebugOverlay = ( props: DebugOverlayProps ) => {
  return (
    <div id="vtiDebugOverlay">

    {
      tableFactory(
      'Current Channel',
      [
        {name: 'id', value: props.activeChannelId},
        {name: 'Phase', value: `${props.phaseNameOfActiveChannel} (${props.phaseIdOfActiveChannel})`}
      ],
      {
        width: '50%'
      }
    )
  }

    {tableFactory(
      'Poller',
      [
        {name: 'pull at', value: props.dateOfNextPhaseChange},
        {name: 'pull in', value: `${props.pullDelay} sec`},
        {name: 'for channel', value: props.getCahnnelIdOfNextPull},
      ],
      {
        width: '50%'
      }
    )}

    {props.channels.map( ( channel: any ) =>
      tableFactory(
        'Channel ' + channel.id,
        [
          {name: 'Phase', value: `${findPhaseNameByPhaseId(props.phases, channel.phase_id)} (${channel.phase_id})`},
          {name: 'length', value: `${(channel.active_phase_end_datetime - channel.active_phase_start_datetime)} sec`},
          {name: 'pull at', value: `${getDateDatetime(channel.active_phase_end_datetime)}`},
          {name: 'start at', value: `${getDateDatetime(channel.active_phase_start_datetime)}`}
        ],
        {
          width: '25%'
        }
      )
    )}
    </div>
  )
}

const getDateDatetime = ( datetime: any ) =>
  new Date(datetime * 1000).toString()

const findPhaseNameByPhaseId = ( phases: any, id: number) =>
  findPhaseByPhaseId(phases, id).name

const findPhaseByPhaseId = ( phases: any, id: number) =>
  phases.find( (phase: any) => phase.id === id)

const tableFactory = ( headline: string, contend:Array<any>, options: any) => {
  const _options = {
    width: '100%',
    ...options
  }

  return (
    <div style={{width: _options.width}} key={headline}>
      <table>
        <tbody>
          {tableHeaderTemplate( headline )}
          {contend.map( ( c: any ) => tableRowPropertyTemplayte( c.name, c.value ) )}
        </tbody>
      </table>
    </div>
  )
}

const tableRowPropertyTemplayte = ( name: string, value: any) => {
  return (
    <tr key={name + value}>
      <td className="name">{name}</td>
      <td>{value}</td>
    </tr>
  )
}

const tableHeaderTemplate = ( name: string ) => {
  return (
    <tr>
      <th colSpan={2}>{name}</th>
    </tr>
  )
}

const mapStateToProps = ( state: any ) => {
  const activeChannelId: number = getActiveChannelId( state )
  const getCahnnelIdOfNextPull: number = getCahnnelIdOfSmallestPhaseChangeDelay( state )
  const activeChannelPhaseId: any = getPhaseIdByChannelId( state, activeChannelId )
  const nextPullChannelPhaseId: any = getPhaseIdByChannelId( state, getCahnnelIdOfNextPull )
  const currentDelta =  getCurrentDelta( state )

  return ({
    channels: getTimings(state),
    activeChannelId: activeChannelId,
    dateOfNextPhaseChange: getDateOfNextPhaseChange(state),
    phaseIdOfActiveChannel: activeChannelPhaseId,
    phaseNameOfActiveChannel: getPhasesNameById( state, activeChannelPhaseId ),
    getCahnnelIdOfNextPull: getCahnnelIdOfNextPull,
    phaseIdOfNextPullChannel: nextPullChannelPhaseId,
    phaseNameOfNextPullChannel: getPhasesNameById( state, nextPullChannelPhaseId ),
    pullDelay: ONE_THOUSAND_MILLISECONDS - currentDelta,
    phases: getPhases( state )
  })
}

export default connect(mapStateToProps)(DebugOverlay)
